<script setup>
import Panel from "@components/settings/Panel.vue";
</script>

<template>
    <div class="contents">
        <Panel />
    </div>
</template>
